import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IOptionType } from '@zz2/zz2-ui';
import { ISite } from '../site/site';
import { IPrintServer } from './printServer';
import { IPrintServerFormValues } from './printServerFormValues';
import { IPrintServerUpsert } from './printServerUpsert';

export default class PrintServerModelHelper {
    public static createFormValues = (
        printServer : IPrintServer | null,
        sites : Array<ISite>
    ) : IPrintServerFormValues => {
        if (!printServer) return {
            id: 0,
            guid: uuidV4(),
            name: '',
            macAddress: '',
            ipAddress: '',
            defaultScheme: 'https',
            primaryUrl: null,
            port: null,
            site: null,
            isMafrodaIntegrated: false,
            isOverrideFlag: false,
            isActive: true,
        };

        const siteOption = sites.find(x => x.id === printServer.siteId);

        return {
            id: printServer.id,
            guid: printServer.guid,
            name: printServer.name,
            macAddress: printServer.macAddress,
            ipAddress: printServer.ipAddress,
            defaultScheme: printServer.defaultScheme,
            primaryUrl: printServer.primaryUrl,
            port: printServer.port,
            site: siteOption != null
                ? { // TODO: OptionType.FromDataModel
                    value: siteOption?.id,
                    label: `(${siteOption.shortDescription}) - ${siteOption.description}`,
                }
                :
                null,
            isMafrodaIntegrated: printServer.isMafrodaIntegrated,
            isOverrideFlag: printServer.isOverrideFlag,
            isActive: printServer.isActive,
        };
    };

    public static createUpsert = (formValues : IPrintServerFormValues) : IPrintServerUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            name: formValues.name,
            macAddress: formValues.macAddress,
            ipAddress: formValues.ipAddress,
            defaultScheme: formValues.defaultScheme,
            primaryUrl: formValues.primaryUrl,
            port: formValues.port,
            siteId: formValues.site ? Number(formValues.site.value) : null,
            isMafrodaIntegrated: formValues.isMafrodaIntegrated,
            isOverrideFlag: formValues.isOverrideFlag,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IPrintServerFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        macAddress: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        ipAddress: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        defaultScheme: Yup.string().trim().defined().nullable(),
        primaryUrl: Yup.string().trim().defined().nullable(),
        port: Yup.number().defined().nullable()
            .min(0, 'Port number must be between 0 and 65535')
            .max(65535, 'Port number must be between 0 and 65535'),
        site: Yup.mixed<IOptionType>().defined().nullable(),
        isMafrodaIntegrated: Yup.boolean().required('Required'),
        isOverrideFlag: Yup.boolean().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
